import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getTotalScoreTrend = createAsyncThunk<any, any>(
  'getTotalScoreTend',
  async (params, thunkApi) => {
    try {
      const response = await api.get(
        `vps/total-score-trend?vendor_id=${params.vendorId}&interval=${params.interval}`,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getRequireUrgentAction = createAsyncThunk<any, any>(
  'getRequireUrgentAction',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`vps/require-urgent-action?vendor_id=${params.vendorId}`, {
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getPerformance = createAsyncThunk<any, any>(
  'getPerformance',
  async (params, thunkApi) => {
    try {
      const response = await api.get(
        `vps/performance?vendor_id=${params.vendorId}&interval=${params.interval}`,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getProductScoreTrends = createAsyncThunk<any, any>(
  'getProductScoreTrends',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`vps/product-score-trends?vendor_id=${params.vendorId}`, {
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getPerformanceOverview = createAsyncThunk<any, any>(
  'getPerformanceOverview',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`vps/performance-overview?vendor_id=${params.vendorId}`, {
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
